// extracted by mini-css-extract-plugin
export var planCard = "_si-0";
export var planList = "_si-1";